import React, { Component } from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import { createBrowserHistory } from "history"

import Main from 'containers/Main';



const history = createBrowserHistory();



class App extends Component {

  render() {
   
    return (
    <div onContextMenu={(e)=>{e.stopPropagation();e.preventDefault();}}>
      <Router history={history}>
        <Switch>
        <Route path="/" component={Main}/>
        </Switch>
      </Router> 
    </div>
    );
  }
}
export default App;